<template>
  <div class="construction_standard">
    <!-- <AntPolySkeleton height="15rem" :num="8" :rows="8" :gutter="80" :loading="loading">
      <Swipers :data="data" :submit="submit" />
    </AntPolySkeleton> -->
    <AntGridSkeleton height="15rem" :num="8" :rows="1" :gap="1" :loading="loading">
      <Swipers :data="data" :submit="submit" />
    </AntGridSkeleton>
  </div>
</template>

<script>
import Swipers from '../swiper';
export default {
  components: { Swipers },
  data() {
    return {
      loading: true,
      data: [],
      cancells: this.$FN.cancells(),
    }
  },
  created() {
    this.getData();
  },
  methods: {
    submit({ id = null, name = null }) {
      this.$FN.limitsTips({ list: ["home_constructionStandard_details"] }).then(res => {
        if (res) {
          this.$router.$push({
            path: "/detailsPage/benchmarking",
            query: { id, name, type: "1" }
          })
        }
      });
    },
    getData() {
      let config = { method: "post", contentType: "1" };
      let form = {
        keywords: "",
        page: 1,
        pageSize: 10,
        isFullText: false
      };
      this.cancells("api/product_service/kres/CVolumeSearchByBook", form, config).then(res => {
        this.loading = false;
        if (res) {
          let { entity = {} } = res;
          this.data = entity.list.map(item => ({
            ...item,
            img: item.coverImg ? `${this.$FN.publicUrl}${item.coverImg}` : require("@/assets/images/public/no_img.png"),
          }));
        }
      })
      // this.$FN.get("/homep/kresList_data.json").then(res => {
      //   this.loading = false;
      //   if (res) {
      //     let { kreslist = [] } = res;
      //     if (kreslist) this.data = kreslist;
      //   }
      // })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>